import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@mui/material'
import Box from '@mui/material/Box'
import PropTypes from 'prop-types'

import {
  OrderChangeState,
  OrderChangeStateActions
} from '../../../../../../types/order.type'

import RecommendedActionsDialogBox from './RecommendedActionsDialogBox'

/**
 * @param {Object} props
 * @param {import('../../../../../../types/order.type').OrderModel} props.order
 */
function RecommendedActions(props) {
  const { order } = props
  const navigate = useNavigate()
  const currentStatus = order.status

  const [dialogIsOpen, setDialogIsOpen] = useState(false)
  const [reqBody, setReqBody] = useState({
    action: null
  })

  const RecommendedActionsButtons = () => {
    switch (currentStatus) {
      case OrderChangeState.ORDERED: {
        return (
          <Button
            variant='filled'
            onClick={() => {
              setDialogIsOpen(true)
              setReqBody({
                action: OrderChangeStateActions.CLIENT_COMPLETE_PAYMENT
              })
            }}
            data-cy='paymentComplete'
          >
            Payment Complete
          </Button>
        )
      }
      case OrderChangeState.PAYMENT_RECEIVED: {
        return (
          <>
            <Button
              variant='filled'
              onClick={() => {
                setDialogIsOpen(true)
                setReqBody({
                  action: OrderChangeStateActions.OPS_START_PREP
                })
              }}
              data-cy='autoProvision'
            >
              Begin Automatic Provisioning
            </Button>
            <Button
              variant='secondary'
              onClick={() =>
                navigate(`/hq/manage-orders/${order.orderNo}/manual-provision`)
              }
              data-cy='manualProvision'
            >
              Manually Provision SIMs
            </Button>
          </>
        )
      }
      case OrderChangeState.PREPARING: {
        return (
          <Button
            variant='filled'
            onClick={() => {
              setDialogIsOpen(true)
              setReqBody({
                action: OrderChangeStateActions.OPS_DONE_PREP
              })
            }}
          >
            Set to Ready For Delivery
          </Button>
        )
      }
      case OrderChangeState.READY_FOR_DELIVERY: {
        return null
        // this redirection doesn't work due to routing issues
        // return (
        //   <Button
        //     variant='primary'
        //     onClick={() =>
        //       navigate(`/app/book-delivery/${order.orderNo}`, { replace: true })}
        //   >
        //     Schedule Delivery
        //   </Button>
        // )
      }
      case OrderChangeState.SCHEDULED_FOR_DELIVERY: {
        return (
          <Button
            variant='secondary'
            onClick={() =>
              navigate(
                `/hq/manage-orders/${order.orderNo}/handle-order-delivery`
              )
            }
          >
            Manage Delivery
          </Button>
        )
      }
      case OrderChangeState.DELIVERY_IN_PROGRESS: {
        return (
          <Button
            variant='filled'
            onClick={() => {
              setDialogIsOpen(true)
              setReqBody({
                action: OrderChangeStateActions.DELIVERY_SUCCESS
              })
            }}
          >
            Confirm Delivery Success
          </Button>
        )
      }
      default: {
        return null
      }
    }
  }

  if (
    currentStatus === OrderChangeState.DELIVERED ||
    currentStatus === OrderChangeState.READY_FOR_DELIVERY
  ) {
    return null
  }

  return (
    <>
      <Box
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box sx={{ marginRight: '10px' }}>
          <strong>Recommended Actions: </strong>
        </Box>
        <RecommendedActionsButtons />
      </Box>
      <RecommendedActionsDialogBox
        isOpen={dialogIsOpen}
        orderNo={order.orderNo}
        onClose={() => {
          location.reload()
          setDialogIsOpen(false)
        }}
        updateStateReqBody={reqBody}
      />
    </>
  )
}

RecommendedActions.propTypes = {
  order: PropTypes.object
}

export default RecommendedActions
